import { Http } from "../Http";
import { AxiosPromise } from "axios";
import { getUserAccessToken } from "../selectors/Accounts";

export default class VideoHotlineCategoryService {
	public static videoHotlineCategoryGetAll(input: any) {
		return Http.axios()
			.post(`/api/EventCategories/GetAllEventCategories`, input, {
				headers: { Authorization: getUserAccessToken() },
			})
			.catch((e: { response: any }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static videoHotlineCategoryStatusUpdate(input: any) {
		return Http.axios()
			.post("/api/EventCategories/updateEventCategoryStatus", input, {
				headers: { Authorization: getUserAccessToken() },
			})
			.then((res: any) => {
				return res;
			})
			.catch((e: any) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static videoHotlineCategoryCreate(input: any) {
		return Http.axios()
			.post("/api/EventCategories/create", input, {
				headers: { Authorization: getUserAccessToken() },
			})
			.then((res: any) => {
				return res;
			})
			.catch((e: any) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static videoHotlineCategoryUpdate(input: any) {
		return Http.axios()
			.post("/api/EventCategories/update", input, {
				headers: { Authorization: getUserAccessToken() },
			})
			.then((res: any) => {
				return res;
			})
			.catch((e: any) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static videoHotlineCategoryDelete(input: any) {
		return Http.axios()
			.delete(`/api/EventCategories/delete/${input}`, {
				headers: { Authorization: getUserAccessToken() },
			})
			.catch((e: { response: any }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static videoHotlineCategoryGetAllActiveCategories() {
		return Http.axios()
			.get(`/api/EventCategories/GetEventCategoriesForDDL`, {
				headers: { Authorization: getUserAccessToken() },
			})
			.catch((e: { response: any }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}
}
